import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PreSubmitErrorMessagesBanner({
  preSubmitErrorMessages,
  setShowRequiredFieldsAlert
}) {
  if (preSubmitErrorMessages.length === 1) {
    return /*#__PURE__*/_jsx(Alert, {
      marginBlockStart: "500",
      type: "danger",
      "data-test-id": "complete-card-payment-required-field-single-error",
      closeable: true,
      onClose: () => {
        setShowRequiredFieldsAlert(false);
      },
      children: preSubmitErrorMessages[0]
    });
  }
  return /*#__PURE__*/_jsx(Alert, {
    marginBlockStart: "500",
    type: "danger",
    "data-test-id": "complete-card-payment-required-field-multiple-errors",
    closeable: true,
    onClose: () => {
      setShowRequiredFieldsAlert(false);
    },
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payments.inputError.reviewErrorsHeader"
    }),
    children: /*#__PURE__*/_jsx(List, {
      styled: true,
      children: preSubmitErrorMessages.map(errorMessage => /*#__PURE__*/_jsx(ListItem, {
        children: errorMessage
      }, errorMessage.key))
    })
  });
}